"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import type { ThemeProviderProps } from "next-themes"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      {...props}
      enableSystem={true}
      disableTransitionOnChange
      attribute="class"
      defaultTheme="light"
    >
      <div suppressHydrationWarning>{children}</div>
    </NextThemesProvider>
  )
}

